import React from 'react';
import koreanMessages from './ra-admin-korean';
import englishMessages from 'ra-language-english';
import { Admin, Resource } from 'react-admin';
import hasuraDataProvider from 'ra-data-hasura';
import { createMuiTheme } from '@material-ui/core/styles';
import { ProductShow, ProductList, ProductEdit, ProductCreate } from './resources/product';
import { AdminList, AdminEdit, AdminCreate } from './resources/admin';
import { SinglePurchaseList } from './resources/singlePurchase';
import { GroupPurchaseList, GroupPurchaseCreate } from './resources/groupPurchase';

const headers = { 'content-type': 'application/json' }
const messages = {
	en: englishMessages,
	kr: koreanMessages,
}
const i18nProvider = locale => messages[locale];
const App = () => (
	<Admin locale="kr" i18nProvider={i18nProvider} theme={createMuiTheme()} dataProvider={hasuraDataProvider('http://aws-cloud9.asuscomm.com:8080', headers)}>
		<Resource name="product" options={{ label: '제품목록' }} list={ProductList} edit={ProductEdit} create={ProductCreate} show={ProductShow} />
		<Resource name="admin" options={{ label: '관리자' }} list={AdminList} edit={AdminEdit} create={AdminCreate} />
		<Resource name="single_purchase" options={{ label: '단일구매' }} list={SinglePurchaseList} />
		<Resource name="group_purchase" options={{ label: '공동구매' }} list={GroupPurchaseList} create={GroupPurchaseCreate} />
	</Admin>
)

export default App;